export default class BeginningBalanceActions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static SUCCESS_DATA='SUCCESS_DATA';
    static ERROR_SERVER='ERROR_SERVER';
    static GET_HELPER ='GET_HELPER';
    static RESET_LIST ='RESET_LIST';

    static submit(){
      return {
        type: BeginningBalanceActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: BeginningBalanceActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: BeginningBalanceActions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: BeginningBalanceActions.VIEW_DATA,
        payload: data
      };
    }
  
    static void(data) {
      return {
        type: BeginningBalanceActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: BeginningBalanceActions.SHOW_DATA,
        payload: data
      };
    }
    static error(error){
      return {
        type: BeginningBalanceActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: BeginningBalanceActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: BeginningBalanceActions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: BeginningBalanceActions.RESET_DATA,
      };
    }
    static resetList(){
      return {
        type: BeginningBalanceActions.RESET_LIST,
      };
    }
  static helper(data){
    return{
      type : BeginningBalanceActions.GET_HELPER,
      payload : data
    };

  }
    static errorInternal(error){
      return {
        type: BeginningBalanceActions.ERROR_SERVER,
        payload: error
      };
    }
  }